import { faClose, faListCheck } from "@fortawesome/free-solid-svg-icons"
import { useTranslation } from "react-i18next"
import Animate, { AnimationTypes } from "../../../components/Animate/Animate"
import { ButtonIcon } from "../../../components/Button/Button"
import { PopupHelpButton } from "../../../components/Help/PopupHelpButton"
import ModalPortal from "../../../components/Modal/ModalPortal"
import { TimeClockCardGrid } from "../../../components/TimeClock/TimeClockCardGrid"
import { TitlePageResponsiveIconSmall } from "../../../components/Titles/Titles"
import { SIZE } from "../../../configuration/Sizes"
import THEME from "../../../configuration/Theme"
import type { ListItem } from "../../../components/List/List"
import defaultStyle from "../../../styles/defaultPageStyle.module.css"
import GetSpace from "../../../utils/space"

interface TimeClockEmployeeEntriesPopupProps {
  employeeName: string
  cards: ListItem[]
  onClose: () => void
}

export const TimeClockEmployeeEntriesPopup: React.FC<TimeClockEmployeeEntriesPopupProps> = ({
  employeeName,
  cards,
  onClose,
}) => {
  const { t } = useTranslation(["timeClock", "helpPopup"])

  return (
    <ModalPortal>
      <div className={defaultStyle.overlay}>
        <Animate type={AnimationTypes.slideUpIn} duration="0.3s">
          <div className={defaultStyle.alert1}>
            <TitlePageResponsiveIconSmall
              title={`${t("timeClock:management.period_entries")} • ${employeeName}`}
              icon={faListCheck}
              iconColor={THEME.colors.iconBGColor}
              children={
                <div className={`${defaultStyle.ButtonsActions} flex items-center gap-1`}>
                  <PopupHelpButton
                    variant="global"
                    helpKey="pages.time-clock-employee-entries"
                    title={t("helpPopup:global.timeClockEmployeeEntries.title")}
                    description={t("helpPopup:global.timeClockEmployeeEntries.description")}
                    bullets={
                      t("helpPopup:global.timeClockEmployeeEntries.bullets", { returnObjects: true }) as string[]
                    }
                  />

                  <ButtonIcon
                    sizeNumber={SIZE.buttonCloseIconSize}
                    bgColor={THEME.colors.buttonBGCloseColor}
                    iconColor={THEME.colors.buttonFGCloseColor}
                    icon={faClose}
                    onClick={onClose}
                    size="small"
                    descriptionKey="interactionDescriptions:pages.myRestaurant.timeClock.timeClockEmployeeEntriesPopup.button.onClose"
                  />
                </div>
              }
            />

            <GetSpace top={10} />

            <div className="max-h-[72vh] overflow-y-auto p-2">
              <TimeClockCardGrid
                items={cards}
                emptyLabel={t("timeClock:management.no_entries")}
                descriptionKey="interactionDescriptions:pages.myRestaurant.timeClock.timeClockEmployeeEntriesPopup.card.entry"
              />
            </div>
          </div>
        </Animate>
      </div>
    </ModalPortal>
  )
}
